import dynamic from 'next/dynamic';
import type * as Recharts from 'recharts';

// Only top-level chart containers are lazy-loaded with SSR disabled.
// Sub-components (Bar, Line, XAxis, etc.) must be direct re-exports so recharts
// can identify them by component identity/displayName internally.

const lazy = (name: string) =>
  dynamic(
    () => import('recharts').then((m) => ({ default: (m as any)[name] })),
    { ssr: false }
  );

// Top-level containers — lazy loaded
export const AreaChart = lazy(
  'AreaChart'
) as unknown as typeof Recharts.AreaChart;
export const BarChart = lazy('BarChart') as unknown as typeof Recharts.BarChart;
export const ComposedChart = lazy(
  'ComposedChart'
) as unknown as typeof Recharts.ComposedChart;
export const LineChart = lazy(
  'LineChart'
) as unknown as typeof Recharts.LineChart;
export const PieChart = lazy('PieChart') as unknown as typeof Recharts.PieChart;
export const RadarChart = lazy(
  'RadarChart'
) as unknown as typeof Recharts.RadarChart;
export const ScatterChart = lazy(
  'ScatterChart'
) as unknown as typeof Recharts.ScatterChart;
export const ResponsiveContainer = lazy(
  'ResponsiveContainer'
) as unknown as typeof Recharts.ResponsiveContainer;
export const Treemap = lazy('Treemap') as unknown as typeof Recharts.Treemap;

// Sub-components — direct re-exports to preserve recharts internal identity checks
export {
  Area,
  Bar,
  CartesianGrid,
  Cell,
  LabelList,
  Legend,
  Line,
  Pie,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  Rectangle,
  ReferenceDot,
  ReferenceLine,
  Scatter,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis,
} from 'recharts';
